import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { TimezoneAwareDatePipe } from '@twaice-fe/frontend/shared/services';
import { selectors } from '@twaice-fe/frontend/shared/store';
import { getTimezoneOffsetFromUtc } from '@twaice-fe/frontend/shared/utilities';
import { CustomUserTimezone } from '@twaice-fe/shared/models';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { BehaviorSubject, interval, withLatestFrom } from 'rxjs';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';

const { authSelectors, systemSelectors } = selectors;

@Component({
  selector: 'twaice-fe-timezone-indicator',
  imports: [CommonModule, SvgIconModule, TimezoneAwareDatePipe, NzPopoverModule],
  templateUrl: './timezone-indicator.component.html',
})
export class TimezoneIndicatorComponent {
  storageTimezone: string;
  userTimezone: string;
  resolvedTimezone: string;
  CustomUserTimezone = CustomUserTimezone;
  getTimezoneOffsetFromUtc = getTimezoneOffsetFromUtc;

  now$ = new BehaviorSubject<Date>(new Date());

  constructor(private store: Store) {
    this.store
      .select(systemSelectors.getSelected)
      .pipe(withLatestFrom(this.store.select(authSelectors.getUserTimezone)), takeUntilDestroyed())
      .subscribe(([system, timezone]) => {
        if (!system) return;

        this.userTimezone = timezone;
        this.storageTimezone = system.bessMetadata?.storageTimezone;

        switch (timezone) {
          case CustomUserTimezone.BROWSER_TIME:
            this.resolvedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            break;
          case CustomUserTimezone.STORAGE_TIME:
            this.resolvedTimezone = system.bessMetadata?.storageTimezone;
            break;
          default:
            this.resolvedTimezone = timezone;
            break;
        }

        this.now$.next(new Date());
      });

    interval(1000)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.now$.next(new Date());
      });
  }

  getDisplayTimezone(timezone: string): string {
    return timezone?.replace('_', ' ');
  }
}
